export const SECTION_CLASS_NAMES = 'pt-4 pb-10';
